var segmentedControlItem = 'fx_2d2fb1e5_1an4y3q0';
var segmentedControlItemClickable = 'fx_2d2fb1e5_1an4y3q1';

export { segmentedControlItem, segmentedControlItemClickable };
//# sourceMappingURL=item.vanilla.mjs.map
